<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>翻新设备</el-breadcrumb-item>
      <el-breadcrumb-item>设备回收请求</el-breadcrumb-item>
    </el-breadcrumb>
    <device-quest-list :category="2"></device-quest-list>
  </div>
</template>

<script>
import DeviceQuestList from './list'
export default {
  components: { DeviceQuestList },
}
</script>